
import styles from '../style.module.css';
import React, {useCallback, useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { getContactInfo } from "store/contactPage/contactPageFetch";
import Map from 'components/Map'
import langData from 'lang/data';
import BranchesSlider from './BranchesSlider';

function Branches() {

    const { currentLanguage } = useSelector(({main}) => main);
    const { contactPage } = useSelector((state) => state.ContactPageSlice);
    const dispatch = useDispatch();
    const defaultCenter = { lat: 40.150011, lng: 44.495715 };
    const [mapCenter, setMapCenter] = useState(defaultCenter);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
        dispatch(getContactInfo()).then(r => r);
    }, [dispatch]);

    useEffect(() => {
        if (contactPage?.addresses?.length > 0) {
            const first = contactPage.addresses[0];
            const center = {
                lat: Number(first?.location?.lat),
                lng: Number(first?.location?.lng),
            };
            setMapCenter(center);
            setSelectedIndex(0);
            setSelected({ lat: center.lat, lng: center.lng });
        }
    }, [contactPage]);

    const handleMarkerClick = (address) => {
        const lat = parseFloat(address?.location?.lat) || defaultCenter.lat;
        const lng = parseFloat(address?.location?.lng) || defaultCenter.lng;
        setSelected({ lat, lng });
    };

    const handleAddressClick = useCallback((lat, lng, index) => {
        if (lat && lng) {
            setMapCenter({ lat, lng });
            setSelectedIndex(index);
        }
    }, []);

    return (
        <div className = {styles.branches_section}>
            <h3>{ langData.branches[currentLanguage] }</h3>
            <BranchesSlider
                addresses = { contactPage?.addresses }
                selectedIndex = { selectedIndex }
                setSelectedIndex = { setSelectedIndex }
                handleMarkerClick = { handleMarkerClick }
                handleAddressClick = { handleAddressClick }
            />
            <Map
                addresses={contactPage?.addresses}
                mapCenter={mapCenter}
                selectedIndex={selectedIndex}
                selected={selected}
                setSelected={setSelected}
                handleMarkerClick={handleMarkerClick}
                setMapCenter={setMapCenter}
            />
        </div>
    )
}

export default Branches;